import { GuideBanner } from './guid-banner';
import { Block } from './block';

export interface Guide {
  id?: string;
  banner: GuideBanner;
  blocks: Block[];
}

export class GuideClass implements Guide {
  id?: string;
  banner: GuideBanner;
  blocks: Block[];

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.banner = o['banner'] ?? null;
    this.blocks = o['blocks'] ?? [];
  }
}
